import Id from './IdFactory';
import ErrorIcon from '@material-ui/icons/Error';
/*
const data = [
  {target:"Phospho-p65",supplier:"Cell Signaling Technology"},
  {target:"ERK",supplier:"Cell Signaling Technology"},
  {target:"phospho-ERK",supplier:"Cell Signaling Technology"},
  {target:"phospho- IκBα",supplier:"Cell Signaling Technology"},
  {target:"total IκBα",supplier:"Cell Signaling Technology"},
  {target:"phospho-JNK1/2",supplier:"Cell Signaling Technology"},
  {target:"total JNK1/2",supplier:"Cell Signaling Technology"},
  {target:"cJun",supplier:"Cell Signaling Technology"},
  {target:"cFos",supplier:"Cell Signaling Technology"},
  {target:"GAPDH",supplier:"Cell Signaling Technology"},
  {target:"Ubiquitin",supplier:"Imgenex"},
  {target:"RIPK2",supplier:"Santa Cruz"},
  {target:"total p65",supplier:"Santa Cruz"},
  {target:"JunB",supplier:"Santa Cruz"},
  {target:"p50",supplier:"Santa Cruz"},
  {target:"RelB",supplier:"Santa Cruz"},
  {target:"Lamin A/C",supplier:"Santa Cruz"},
  {target:"β-actin",supplier:"Sigma"},
]
*/

const sc = "Santa Cruz Biotechnology"
const cst = "Cell Signaling Technology"

const data = [
  {target:"NAGK",supplier:"Abcam", supplierID:"ab203900", alternativeSource:"https://www.abcam.com/products/primary-antibodies/nagk-antibody-ab203900.html"},
  {target:"β-actin",supplier:sc, RRID:"AB_2714189"},
  {target:"phospho-p65", supplier:cst, RRID:"AB_331284"},
  {target:"phospho-p38", supplier:cst, RRID:"AB_331641"},
  {target:"RIPK2", supplier:cst, RRID:"AB_2716277"},
  {target:"phospho-IκBɑ",supplier:cst,RRID:"AB_2267145"},
  {target:"Anti-mouse IgG",supplier:cst,RRID:"AB_330924"},
  {target:"Anti-rabbit IgG",supplier:cst,RRID:"AB_2099233"}
]



const missingRRIDs = [];//3,6];
/*
data.forEach((item,ii) => {
  if( !missingRRIDs.includes(ii) ){
    data[ii].rrid = "AB_"+(Id().split('-')[0]).toUpperCase()
  }
})
*/

const error = (
    <div class="sg-row v-center">
            <ErrorIcon style={{color:'#bf0000'}}/>
  </div>

)
export default function SupplementReagents(){


  const headings = ["✓","Target","RRID","Supplier"]
  const header = (
    <tr>
      {headings.map(val => {
        return (
          <td style={{
            fontWeight:'bold',
            background:'#eee',
          }}>
            {val}
          </td>
        )
      })}
    </tr>
  )

  let numMissing = data.filter(x => !x.RRID).length;

  return (

    <div style={{
      //borderTop:'1px solid #ccc',
      //paddingTop:20,
      minHeight:0,
      overflow:'scroll',
    }} class="fair-margin full-height sg-row">

      <div>
        <h3>Reagent Summary</h3>

        <div class="sg-row fair-padding-right">
          <div style={{border:'3px solid red', paddingRight:30, 
            paddingTop:20,
          }}>
            <ul> 
              <li>{numMissing} <b>antibodies</b> missing RRIDs</li>
              <ul>
                {missingRRIDs.map(xx => <li>{data[xx].target}</li>)}
              </ul>
            </ul>
          </div>
        </div>
      </div>

      <div>

        <h4>Antibodies</h4>

        <div class="">
          <table class="td-padding" style={{fontSize:18}}>
            {header}
            {data.map(data => {
              return (
                <tr>
                  <td>
                    {!data.RRID && error}
                  </td>
                  <td>{data.alternativeSource? <a target="_blank" href={data.alternativeSource}>{data.target}</a> : data.target}</td>
                  {data.RRID ? (<td><a target="_blank" href={`http://antibodyregistry.org/${data.RRID}`}>
                    {data.RRID}
                    </a></td>) : (
                    <td style={{color:'red', fontWeight:'bold'}}>
                      Missing RRID
                    </td>
                  )}
                  <td>{data.supplier}</td>
                </tr>
              )
            })}
          </table>
        </div>
      </div>
    </div>
  )
}
